import { orchestrator } from "satcheljs";
import { TeamDataService } from "sh-services";
import { TeamStore } from "sh-team-store";
import getScheduleDataInCustomDateRange from "../actions/getScheduleDataInCustomDateRange";

/**
 * Gets the schedule data (shifts and notes) for a custom date range
 */
export const getScheduleDataInCustomDateRangeOrchestrator = orchestrator(getScheduleDataInCustomDateRange, async actionMessage => {
    if (TeamStore() && TeamStore().team) {
        await TeamDataService.getDataInDateRange(
            TeamStore().teamId,
            actionMessage.startDate,
            actionMessage.endDate,
            actionMessage.forceLoad
        );
    }
});